import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "container-fluid d-flex justify-content-between position-fixed start-0 bottom-0 border-top bg-light px-5",
  style: {"z-index":"1046","height":"22px","min-width":"950px"}
}
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-sm py-0 mx-1",
  title: "Level Inspection"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-list" })
], -1)
const _hoisted_4 = { id: "popperVia" }
const _hoisted_5 = { style: {"min-width":"300px"} }
const _hoisted_6 = { class: "mx-2" }
const _hoisted_7 = { class: "mx-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PanelLevelVue = _resolveComponent("PanelLevelVue")!
  const _component_Popper = _resolveComponent("Popper")!
  const _component_LevelVue = _resolveComponent("LevelVue")!
  const _component_PopperWrapperGreen = _resolveComponent("PopperWrapperGreen")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Popper, null, {
        content: _withCtx(() => [
          _createVNode(_component_PanelLevelVue)
        ]),
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_PopperWrapperGreen, {
          content: "Please select the layer to which the via should connect.",
          arrow: true,
          show: _ctx.showPopper
        }, {
          default: _withCtx(() => [
            _createVNode(_component_LevelVue, {
              onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.controlStore.hidePopper()))
            })
          ]),
          _: 1
        }, 8, ["show"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", _hoisted_6, "Snap Precision: " + _toDisplayString(_ctx.coordinate.precision) + " μm", 1),
      _createElementVNode("span", _hoisted_7, "Grid Size: " + _toDisplayString(_ctx.coordinate.precisionGrid) + " μm", 1)
    ]),
    _createElementVNode("span", null, "X: " + _toDisplayString(_ctx.coordinate.roundedGlobalCoords[0].toFixed()) + " µm, Y: " + _toDisplayString(_ctx.coordinate.roundedGlobalCoords[1].toFixed()) + " µm", 1)
  ]))
}